var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, Modal, ModalBody, ModalFoot, ModalHead, Text, } from '@dixa/lib-shared-habla';
import { useState } from 'react';
import { smsApi } from 'apis/sms';
import { QueueSelect } from 'components/queueSelect';
import { NotificationType, useNotifications } from 'hooks/useNotifications';
import { createAppModal } from 'utils/modal';
import styles from './editSmsQueueModal.module.scss';
/** A component that displays a modal for changing the sms queue. */
export const EditSmsQueueModal = createAppModal({ type: 'settings:editSmsQueue' }, ({ isOpen, modal, hide }) => {
    var _a;
    const notify = useNotifications();
    const [selectedQueue, setSelectedQueue] = useState();
    const [updateSmsNumberQueue, { isLoading }] = smsApi.useUpdateSmsNumberQueueMutation();
    /** Handles closing the modal. */
    const handleClose = () => {
        setSelectedQueue(undefined);
        hide === null || hide === void 0 ? void 0 : hide();
    };
    /** Handles selecting a queue. */
    const handleQueueSelect = ({ id, name, is_archived }) => {
        setSelectedQueue({ id, name, is_archived });
    };
    /** Handles confirming a queue. */
    const handleConfirm = () => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        if (selectedQueue &&
            selectedQueue.id !== ((_b = modal.arg.smsTableDataItem.queue) === null || _b === void 0 ? void 0 : _b.id)) {
            try {
                yield updateSmsNumberQueue({
                    phoneNumber: modal.arg.smsTableDataItem.phoneNumber.e164_format,
                    queueId: selectedQueue.id,
                }).unwrap();
                notify({
                    title: 'Queue successfully updated',
                    time: 3000,
                }, NotificationType.Success);
                handleClose();
            }
            catch (_c) {
                notify({
                    title: 'An error occured while updating the queue',
                }, NotificationType.Error);
            }
        }
    });
    return (_jsxs(Modal, Object.assign({ isOpen: isOpen, onClose: handleClose, className: styles.modal }, { children: [_jsx(ModalHead, { title: _jsxs(FlexBox, Object.assign({ alignItems: "baseline", gap: "200" }, { children: [_jsx(Text.Heading, { children: "Edit text message queue" }), _jsx(Text.Paragraph, Object.assign({ subdued: true }, { children: modal.arg.smsTableDataItem.phoneNumber.e164_format }))] })), onClose: handleClose }), _jsx(ModalBody, { children: _jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "400" }, { children: [_jsx(Text.Paragraph, Object.assign({ subdued: true }, { children: "Please select which queue all incoming text messages will go to." })), _jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "200" }, { children: [_jsx(Text.Paragraph, Object.assign({ variant: "3" }, { children: "Queue for incoming text messages" })), _jsx(QueueSelect, { selectedQueue: modal.arg.smsTableDataItem.queue, onSelect: handleQueueSelect })] }))] })) }), _jsx(ModalFoot, { cancelOnClick: handleClose, confirmName: "Update", confirmOnClick: handleConfirm, confirmProps: {
                    disabled: !selectedQueue ||
                        selectedQueue.id === ((_a = modal.arg.smsTableDataItem.queue) === null || _a === void 0 ? void 0 : _a.id),
                    isLoading,
                } })] })));
});
